var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("table", { staticClass: "table-borderless w-100" }, [
    _c(
      "tbody",
      [
        _c("tr", [
          _c("td", [
            _c("div", [
              _vm.isMaintenance
                ? _c("span", [
                    _c("strong", [_vm._v(_vm._s(_vm.$t("txtCellName")))])
                  ])
                : _c("span", [_vm._v(_vm._s(_vm.$t("txtObjectName")))]),
              _vm._v(" "),
              _vm.cellExistsWithName
                ? _c("span", { staticStyle: { color: "var(--danger)" } }, [
                    _vm._v(_vm._s(_vm.$t("cellExistsWithSameName")))
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.cell.name,
                  expression: "cell.name"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.cell.name },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.cell, "name", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("td", [
            _vm.isMaintenance
              ? _c("div", [_vm._v(_vm._s(_vm.$t("txtLine")))])
              : _c("div", [_vm._v(_vm._s(_vm.$t("txtArea")))]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.cell.lineId,
                    expression: "cell.lineId"
                  }
                ],
                staticClass: "form-control",
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.cell,
                      "lineId",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  }
                }
              },
              [
                _c("option", { attrs: { disabled: "", value: "" } }, [
                  _vm._v(_vm._s(_vm.$t("comSelected")))
                ]),
                _vm._v(" "),
                _vm._l(_vm.lines, function(item, index) {
                  return _c("option", { domProps: { value: item.id } }, [
                    _vm._v(
                      "\n            " + _vm._s(item.name) + "\n          "
                    )
                  ])
                })
              ],
              2
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "tr",
          [
            _vm.isMaintenance
              ? [
                  _c("td", [
                    _c("div", [_vm._v(_vm._s(_vm.$t("txtSupplier")))]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.cell.supplier,
                          expression: "cell.supplier"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: { value: _vm.cell.supplier },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.cell, "supplier", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("div", [_vm._v(_vm._s(_vm.$t("txtDescription")))]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.cell.description,
                          expression: "cell.description"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: { value: _vm.cell.description },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.cell, "description", $event.target.value)
                        }
                      }
                    })
                  ])
                ]
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "tr",
          [
            _vm.isMaintenance
              ? [
                  _c("td", [
                    _c("div", [
                      _c("span", [_vm._v(_vm._s(_vm.$t("txtIdent")))]),
                      _vm._v(" "),
                      _vm.cellExistsWithIdent
                        ? _c(
                            "span",
                            { staticStyle: { color: "var(--danger)" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("cellExistsWithSameIdent")) +
                                  "\n            "
                              )
                            ]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.cell.ident,
                          expression: "cell.ident"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: { value: _vm.cell.ident },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.cell, "ident", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("div", { staticClass: "d-inline-block w-50" }, [
                      _vm._v(_vm._s(_vm.$t("txtCostCenter")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-inline-block" }, [
                      _vm._v(_vm._s(_vm.$t("cellCostPerHour")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.cell.costCenter,
                            expression: "cell.costCenter"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.cell.costCenter },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.cell,
                              "costCenter",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.cell.ratePerHour,
                            expression: "cell.ratePerHour"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "number", lang: _vm.$i18n.locale },
                        domProps: { value: _vm.cell.ratePerHour },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.cell,
                              "ratePerHour",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ])
                ]
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "tr",
          [
            _vm.isMaintenance
              ? [
                  _c("td", { staticClass: "w-50" }, [
                    _c("div", { staticClass: "d-inline-block w-50" }, [
                      _vm._v(_vm._s(_vm.$t("txtMeterStart")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-inline-block" }, [
                      _vm._v(_vm._s(_vm.$t("txtMeterStartUnit")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.cell.engineHours,
                            expression: "cell.engineHours"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.cell.engineHours },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.cell,
                              "engineHours",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.cell.engineHoursUnit,
                            expression: "cell.engineHoursUnit"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.cell.engineHoursUnit },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.cell,
                              "engineHoursUnit",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("div", { staticClass: "d-inline-block w-50" }, [
                      _vm._v(_vm._s(_vm.$t("txtOpcPath")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-inline-block" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("maintenance.cell.model.yearOfManufacture")
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group" }, [
                      _c("input", {
                        staticClass: "form-control",
                        attrs: { type: "text" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.number",
                            value: _vm.cell.yearOfManufacture,
                            expression: "cell.yearOfManufacture",
                            modifiers: { number: true }
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "number",
                          min: "1900",
                          max: "2200",
                          step: "1"
                        },
                        domProps: { value: _vm.cell.yearOfManufacture },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.cell,
                              "yearOfManufacture",
                              _vm._n($event.target.value)
                            )
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ])
                  ])
                ]
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "tr",
          [
            _vm.isMaintenance
              ? [
                  _c("td", [
                    _c("div", [_vm._v(_vm._s(_vm.$t("cellLabel")))]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.cell.label,
                          expression: "cell.label"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: { value: _vm.cell.label },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.cell, "label", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("div", { staticClass: "d-inline-block w-50" }, [
                      _vm._v(_vm._s(_vm.$t("cellMisc")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-inline-block" }, [
                      _vm._v(_vm._s(_vm.$t("cell.risk")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.cell.misc,
                            expression: "cell.misc"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.cell.misc },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.cell, "misc", $event.target.value)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.number",
                            value: _vm.cell.risk,
                            expression: "cell.risk",
                            modifiers: { number: true }
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "number", lang: _vm.$i18n.locale },
                        domProps: { value: _vm.cell.risk },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.cell,
                              "risk",
                              _vm._n($event.target.value)
                            )
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ])
                  ])
                ]
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _vm.isMaintenance
          ? [
              _c("tr", [
                _c("td", { attrs: { colspan: "2" } }, [
                  _c("div", [_vm._v(_vm._s(_vm.$t("txtComment")))]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.cell.comment,
                        expression: "cell.comment"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { cols: "40", rows: "5" },
                    domProps: { value: _vm.cell.comment },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.cell, "comment", $event.target.value)
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _vm.cell.id
                ? _c("tr", [
                    _c("td", [
                      _c("div", [_vm._v(_vm._s(_vm.$t("txtLastUpdate")))]),
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.cell.commentLastUpdate
                              ? _vm.cell.commentLastUpdate.toLocaleDateString() +
                                  " " +
                                  _vm.cell.commentLastUpdate.toLocaleTimeString()
                              : "(none)"
                          ) +
                          "\n        "
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("tr", [
                _c("td", { attrs: { colspan: "2" } }, [
                  _c("div", { staticClass: "form-group form-check" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.cell.isCreateIfNoActivity,
                          expression: "cell.isCreateIfNoActivity"
                        }
                      ],
                      staticClass: "form-check-input",
                      staticStyle: {
                        transform: "scale(1.75)",
                        "margin-left": "-1rem"
                      },
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.cell.isCreateIfNoActivity)
                          ? _vm._i(_vm.cell.isCreateIfNoActivity, null) > -1
                          : _vm.cell.isCreateIfNoActivity
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.cell.isCreateIfNoActivity,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.cell,
                                  "isCreateIfNoActivity",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.cell,
                                  "isCreateIfNoActivity",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.cell, "isCreateIfNoActivity", $$c)
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticStyle: { "margin-left": "0.625rem" } }, [
                      _vm._v(_vm._s(_vm.$t("cellCreateIfNoActivity")))
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.isFireProtection
                ? _c("tr", [
                    _c("td", [
                      _c("div", { staticClass: "form-group form-check" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.cell.isFireProtection,
                              expression: "cell.isFireProtection"
                            }
                          ],
                          staticClass: "form-check-input",
                          staticStyle: {
                            transform: "scale(1.75)",
                            "margin-left": "-1rem"
                          },
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.cell.isFireProtection)
                              ? _vm._i(_vm.cell.isFireProtection, null) > -1
                              : _vm.cell.isFireProtection
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.cell.isFireProtection,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.cell,
                                      "isFireProtection",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.cell,
                                      "isFireProtection",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.cell, "isFireProtection", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "badge badge-danger",
                            staticStyle: { "margin-left": "0.625rem" }
                          },
                          [_vm._v(_vm._s(_vm.$t("fireProtectionBadge")))]
                        )
                      ])
                    ])
                  ])
                : _vm._e()
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }